// extracted by mini-css-extract-plugin
export default {"container":"styles_container__wii48","release_date":"styles_release_date__qwIpW"};